<template>
  <v-card color="#242526">
    <v-card-title>
      <v-btn icon>
        <v-icon color="grey" @click="$emit('go-back')">mdi-arrow-left</v-icon>
      </v-btn>
      <div style="font-size: 20px"><b>Asociar factura pre-impresa</b></div>

      <v-spacer></v-spacer>
      <v-btn icon>
        <v-icon color="grey" @click="$emit('close-dialog')">mdi-close</v-icon>
      </v-btn>
    </v-card-title>
    <v-card-text>
      <v-row justify="center">
        <v-col cols="3">
          <v-text-field label="Punto de venta" disabled :value="preImpreso.punto_de_venta"> </v-text-field>
        </v-col>
        <v-col>
          <v-text-field label="Tipo de comprobante" :value="`Factura ${preImpreso.letra}`" disabled>
          </v-text-field>
        </v-col>
        <v-col cols="4">
          <v-text-field label="Nro de factura" v-model="preImpreso.numero"> </v-text-field>
        </v-col>
      </v-row>

      <v-row justify="end" class="text-end">
        <v-col>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title> CAI: {{preImpreso.cai}} </v-list-item-title>
              <v-list-item-subtitle> Vto: {{moment(preImpreso.vto_cai).format('DD-MM-YYYY')}} </v-list-item-subtitle>
            
            </v-list-item-content>
          </v-list-item>
        </v-col>
      </v-row>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>

      <v-btn color="info" @click="$emit('go-back')" text>
        <b> Cancelar </b>
      </v-btn>
      <v-btn :loading="loadingFacturar" @click="registrarPreImpreso" color="info">
        <b> Facturar </b>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
            import VentasApi from "@/api/venta/venta";

export default {
    name: 'pre-impreso.form',
    props: {
        comprobante: {
            type: Object,
            required: true
        }
    },
    data () {
        return {
            loadingFacturar : false,
            preImpreso: null

        }
    },
    methods: {
        async registrarPreImpreso(){
            try {
               const response = await VentasApi.facturarPreImpreso(this.comprobante.id, this.preImpreso);

            this.$updateBus.$emit("showSnackBar", {
            show: true,
            button: false,
            color: "success",
            text: `Comprobante facturado`,
            icon: "mdi-check",
            timeout: 3000,
            });
            this.$router.push('/ventas')

            } catch (error) {
               this.$updateBus.$emit("showSnackBar", {
            show: true,
            button: false,
            color: "info",
            text: `Problema inesperado`,
            icon: "mdi-information",
            timeout: 3000,
            });
            }
        
        },
        fetchDatosPreImpreso(){
             this.axios.get(`afipfiscal/preimpreso/${this.comprobante.id}?siguiente=true`).then((response) => {
             this.preImpreso = response.data
             });
        }
    },
    created(){
        this.fetchDatosPreImpreso()
    }
}
</script>

<style lang="scss" scoped></style>
